import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { NavigationEnd, Router } from '@angular/router';

import { getMenuItemsList, menuItemsListForSecurity } from '../../definitions/menu-items-list';
import { MenuItemInterface } from '../../interfaces/menu.interface';
import { MainTitle } from '../../models/main-title';
import { AuthService } from '../../shared-components/ng-login/auth/auth.service';
import { getStorageObject } from '../../utils/storage-manager';

export const securityDomain = 'security';
export const securityDomainUS = 'us-security';
export const allSecurityDomains = [securityDomain, securityDomainUS];

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {
  /**
   * Reference to the sidenav child component.
   */
  @ViewChild(MatSidenav, { static: true }) sidenav!: MatSidenav;

  /**
   * Menu items
   */
  protected menuItems: MenuItemInterface[] =
    getStorageObject('vertical').domain === securityDomain ? menuItemsListForSecurity : getMenuItemsList();

  /**
   * Bottom menu items
   */
  public bottomMenuItems: MenuItemInterface[] = [];

  /**
   * Main view title
   */
  public mainTitle!: MainTitle;

  /**
   * Top menu items
   */
  public topMenuItems: any[] = [];

  /**
   * Extra css class to be applied
   */
  public extraClass = '';

  /**
   * @param router - Router Service
   * @param authService - Auth Service
   */
  constructor(public router: Router, protected authService: AuthService) {}

  ngOnInit(): void {
    this.checkActiveMenuItem(this.router.url);
    this.router.events.subscribe((ne) => {
      if (ne instanceof NavigationEnd) {
        this.checkActiveMenuItem(ne.urlAfterRedirects);
      }
    });
  }

  /**
   * Check the current path and highlight the menu icon of the selected section
   * @param originalUrl
   */
  checkActiveMenuItem(originalUrl: string): void {
    let url = originalUrl;
    if (originalUrl[0] === '/') {
      // Remove heading slash
      url = originalUrl.substr(1);
    }

    const firstUrlComponent = url.split('/')[0];
    [...this.menuItems, ...this.bottomMenuItems].forEach((menuItem) => {
      menuItem.active = menuItem.match.indexOf(firstUrlComponent) !== -1;
    });

    // Check URLs on top menu items
    if (this.topMenuItems) {
      this.topMenuItems.forEach((menuItem: any) => {
        menuItem.active = menuItem.url === originalUrl;
      });
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  routeActivated(componentRef: any): void {
    setTimeout(() => {
      try {
        this.mainTitle = componentRef.title;
        this.extraClass = componentRef.extraClass;
        this.topMenuItems = componentRef.topMenuItems;
      } catch (e) {
        this.mainTitle = new MainTitle('');
        this.extraClass = '';
        this.topMenuItems = [];
      }
    });
  }
}
